module.exports = __webpack_public_path__ + "booking.svg?47fbb17fb7ab46d09a57a5358c029a74";